// =============================
// Imports
// =============================

import { Fragment, PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _get from 'lodash/get';

import { setEntityActionsOpen } from '../../../../store/actions/ModalsActions';
import { getMedia, pause, play } from '../../../../store/actions/PlayerActions';

import * as pth from '../../../../helpers/proptypes';

import * as playerStates from '../../../../store/constants/PlayerStates';

import { Actions, PlayButton, PauseButton, ThreeDotIcon, ThreeDotButton } from './styles';

// =============================
// Component
// =============================

class EntityActions extends PureComponent {
  static displayName = 'EntityActionsMobile';

  static propTypes = {
    doc: PropTypes.oneOfType([pth.catalog, pth.album, pth.artist, pth.playlist, pth.userplaylist]),
    hasTracks: PropTypes.bool.isRequired,
    /** Function used to open Entity Action modal. */
    openEntityActionModal: PropTypes.func.isRequired,
    onGetMedia: PropTypes.func.isRequired,
    onPause: PropTypes.func.isRequired,
    onPlay: PropTypes.func.isRequired,
    playerContext: PropTypes.string.isRequired,
    playerStore: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
    t: PropTypes.func.isRequired,
    type: PropTypes.oneOf([
      'catalog',
      'album',
      'artist',
      'playlist',
      'userplaylist',
      'user_favorites',
      'user_recents',
    ]).isRequired,
  };

  static defaultProps = {
    doc: null,
  };

  isPlaying = () => {
    const { doc, playerContext, playerStore } = this.props;

    const contextId = doc ? doc.id : null;

    return !!(
      _get(playerStore, 'contextName', null) === playerContext
      && _get(playerStore, 'contextId', null) === contextId
      && _get(playerStore, 'playerState') === playerStates.PLAYING
    );
  };

  isPaused = () => {
    const { playerContext, playerStore } = this.props;

    return !!(
      _get(playerStore, 'contextName', null) === playerContext
      && _get(playerStore, 'playerState') === playerStates.PAUSED
    );
  };

  handleOnPlay = () => {
    const { doc, onGetMedia, onPause, onPlay, playerContext } = this.props;

    // Pause if a track in being played within the context
    if (this.isPlaying()) {
      return onPause();
    }

    // If the current context is same as prop and the state is paused,
    // we are resuming the previous track within current context
    if (this.isPaused()) {
      return onPlay();
    }

    return onGetMedia(null, playerContext, doc ? doc.id : null);
  };

  render() {
    const { doc, hasTracks, openEntityActionModal, t, type } = this.props;

    return (
      <Actions>
        {hasTracks && (
          <Fragment>
            {this.isPlaying() ? (
              <PauseButton onClick={this.handleOnPlay}>
                {t('components:entity_actions.pause')}
              </PauseButton>
            ) : (
              <PlayButton onClick={this.handleOnPlay}>
                {t('components:entity_actions.play')}
              </PlayButton>
            )}
          </Fragment>
        )}

        {['album', 'playlist', 'userplaylist'].includes(type) && (
          <ThreeDotButton onClick={() => openEntityActionModal(true, doc, type)}>
            <ThreeDotIcon />
          </ThreeDotButton>
        )}
      </Actions>
    );
  }
}

function mapStateToProps({ player }) {
  return {
    playerStore: player,
  };
}

export default connect(mapStateToProps, {
  onGetMedia: getMedia,
  onPause: pause,
  onPlay: play,
  openEntityActionModal: setEntityActionsOpen,
})(EntityActions);
